import React from 'react';
import { Box, Typography } from '@mui/material';
import { SL_ESTIMATOR_TEAL, SL_ESTIMATOR_TEAL_HOVER } from '../../helper/surplusLinesTaxEstimatorStyles';

type SurplusLinesTaxEstimatorStateCardProps = {
  stateName: string;
  subtitle?: string;
  onClick: () => void;
};

export const SurplusLinesTaxEstimatorStateCard: React.FC<SurplusLinesTaxEstimatorStateCardProps> = ({
  stateName,
  subtitle,
  onClick,
}) => (
  <Box
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    }}
    sx={{
      backgroundColor: SL_ESTIMATOR_TEAL,
      borderRadius: '16px',
      border: '1px solid #1e4a56',
      minHeight: '120px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      px: 2,
      py: 2.5,
      transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        backgroundColor: SL_ESTIMATOR_TEAL_HOVER,
        boxShadow: '0 4px 12px rgba(30, 74, 86, 0.3)',
      },
    }}
  >
    <Typography
      sx={{
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '1.125rem',
        letterSpacing: '0.04em',
        textAlign: 'center',
        textTransform: 'uppercase',
        lineHeight: 1.3,
      }}
    >
      {stateName}
    </Typography>
    {subtitle && (
      <Typography
        sx={{
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '0.9375rem',
          letterSpacing: '0.06em',
          textAlign: 'center',
          textTransform: 'uppercase',
          mt: 0.75,
          opacity: 0.95,
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SurplusLinesTaxEstimatorStateCard;
